import {useTranslation} from 'react-i18next';
import {Stack, Typography} from '@mui/material';
import {Modal, ModalProps} from '../modal/modal';
import {translations} from '../../i18n/translations';
import './notification-modal.scss';

interface NotificationsAllReadModalProps extends Omit<ModalProps, 'actions'> {
  open: boolean;
  submitting: boolean;
  onClose: () => void;
  onRead: () => void;
}

export const NotificationsAllReadModal = ({
  open,
  submitting,
  onClose,
  onRead,
}: NotificationsAllReadModalProps) => {
  const {t} = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="notifications-allread-modal"
      preventCloseClick
      title=""
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.modal.confirm),
          type: 'nondestructive',
          onClick: onRead,
          loading: submitting,
        },
      ]}
    >
      <Stack>
        <Typography className="title">
          {t(translations.notifications.read_all_notifications_dialog_title)}
        </Typography>
        <Typography className="subtitle">
          {t(translations.notifications.read_all_notifications_dialog_content)}
        </Typography>
      </Stack>
    </Modal>
  );
};
